import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { deleteData, getData, patchData, postData } from "src/utils/axios/serverHelper";

import { PRD1010_R01Dto } from "./Dto_PRD1010_R01";
import { PRD1010_R01Filter } from "./Store_PRD1010_R01";

const baseUrl = `${config.apiUrl}/PRD1010_R01`;

export const getPRD1010_R01List = async (option: string, params: Partial<PRD1010_R01Filter>, listLength: number = 0) => {
    const url = `${baseUrl}/${option}`
    return await getData<ResponseDto<PRD1010_R01Dto[]>>(url, {
        params: { 
            ...params,
            listLength: listLength ?? 0
        } as PRD1010_R01Filter
    });
}

export const getPRD1010_R01AllCount = async (params: Partial<PRD1010_R01Filter>) => {
    const url = `${baseUrl}/allCount`;
    return await getData<ResponseDto<number>>(url, {
        params: { 
            ...params
        } as PRD1010_R01Filter
    });
}

export const postPRD1010_R01 = async (data: PRD1010_R01Dto[]) => {
    const url = `${baseUrl}`;

    return await postData<PRD1010_R01Dto[], ResponseDto<PRD1010_R01Dto[]>>(url, data);
}

export const patchPRD1010_R01 = async (data: PRD1010_R01Dto[]) => {
    const url = `${baseUrl}`;

    return await patchData<PRD1010_R01Dto[], ResponseDto<PRD1010_R01Dto[]>>(url, data);
}

export const disablePRD1010_R01 = async (data: string[]) => {
    const url = `${baseUrl}/disable`;
    return await patchData<string[], ResponseDto<any>>(url, data);
}

export const deletePRD1010_R01 = async (data: Pick<PRD1010_R01Dto, 'yearMonth' | 'compCd' | 'itemCd'>) => {
    return await deleteData<ResponseDto<any>>(baseUrl, { params: data });
}

export const downloadExcel_PRD1010_R01 = async (option: string, params: Partial<PRD1010_R01Filter>, listLength: number = 0) => {
    
    const url = `${baseUrl}/excel/${option}`

    return await getData<ResponseDto<string>>(url, {
        params: { 
            ...params,
            listLength: listLength ?? 0 
        } as PRD1010_R01Filter
    });
}
export const getPdfBlob_PRD1010_R01 = async (option: string, params: Partial<PRD1010_R01Filter>, listLength: number = 0, documentCompCd: string): Promise<Blob> => {
	const url = `${baseUrl}/print`;
	const response = await getData<Blob>(url, {
		params: {
			...params,
			listLength: listLength ?? 0,
			documentCompCd: documentCompCd
		} as PRD1010_R01Filter,
		responseType: "blob",
	});
	return new Blob([response.data], { type: "application/pdf" });
};
